var _path, _circle, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.889 14.939L29.45 17.5L28.389 18.561L27.689 17.861C27.246 20.6189 25.8353 23.1289 23.7096 24.941C21.5839 26.7532 18.8823 27.749 16.089 27.75C13.4551 27.7542 10.8967 26.8695 8.82805 25.239L8.55105 25.014L9.51405 23.864C11.356 25.4094 13.6847 26.2545 16.089 26.25C18.5021 26.2501 20.8379 25.399 22.6853 23.8466C24.5327 22.2943 25.7734 20.14 26.189 17.763L25.389 18.563L24.328 17.5L26.889 14.939ZM16.089 4.25001C18.1958 4.24703 20.2642 4.81295 22.076 5.88801L22.41 6.09401L21.602 7.35801C19.9563 6.30508 18.0428 5.74696 16.089 5.75001C13.586 5.75026 11.1695 6.66621 9.29521 8.32519C7.4209 9.98416 6.21826 12.2715 5.91405 14.756L6.61405 14.056L7.67505 15.117L6.17505 16.617L5.11005 17.682L2.55005 15.121L3.61105 14.06L4.39605 14.845C4.68293 11.9429 6.03868 9.25115 8.19975 7.29301C10.3608 5.33488 13.1728 4.25026 16.089 4.25001Z",
    fill: "currentColor",
    fillOpacity: 0.7
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 5.375,
    stroke: "currentColor",
    strokeWidth: 1.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1 13.6V18.1",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinecap: "square"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.85 15.85L18.35 15.85",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuPlus);
export default __webpack_public_path__ + "static/media/menu-plus.f1444afc1f22a17a76046b7b88bfc2aa.svg";
export { ForwardRef as ReactComponent };